/** Shared allowlist check for every outstanding-broadcast kind — one place to fix trimming/case rules. */
export function isTenantInOutstandingBroadcastAllowlist(
  tenantId: string | null | undefined,
  allowedTenantIds: ReadonlySet<string>
): boolean {
  return allowedTenantIds.has((tenantId || "").trim());
}
